<template>
  <div class="">
    <p class="header_">消息中心</p>
    <div class="pad_t"></div>
    <div class="list">
      <van-swipe-cell v-for="(item, index) in dataList" :key="item.id">
        <div
          @click="toDetail(item.to, item.id)"
          class="inner m_flex_box flex_vc"
        >
          <div class="left">
            <span class="onRead" v-if="item.unread">{{
              item.unread >= 99 ? "99+" : item.unread
            }}</span>
            <img v-if="item.type === 'xt'" src="@/assets/img/msg.png" alt="" />
            <img
              v-if="item.avatar && item.type !== 'xt'"
              :src="item.avatar"
              alt=""
            />
            <!-- 经纪人判断是否有头像，没有头像用下面的图片 -->
            <img v-else :src="tx" alt="" />
          </div>
          <div class="right">
            <div class="top m_flex_box flex_vc flex_jz">
              <div class="m_flex_box flex_vb">
                <h5>{{ item.type === "xt" ? "系统消息" : item.nick }}</h5>
              </div>
              <span class="time">{{ item.lastMsg.time | formatTime }}</span>
            </div>
            <p class="intro line_comp1" v-if="item.lastMsg.type === 'text'">
              {{ item.lastMsg.text }}
            </p>
            <p class="intro line_comp1" v-else>[图片消息]</p>
          </div>
        </div>
        <template #right>
          <van-button
            square
            type="danger"
            text="删除"
            @click="deleteSession(item.id, index)"
          />
        </template>
      </van-swipe-cell>
    </div>
    <footer-con></footer-con>
  </div>
</template>

<script>
const NIM = require("@/sdk/NIM_Web_NIM_v8.1.0.js");
import { SwipeCell } from "vant";
import footerCon from "@/components/footer";
export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [1, 2, 3, 4],
      tx: require("@/assets/img/tx.jpg"),
      nim: {},
      to: "",
      dataList: [],
      userList: [],
    };
  },
  components: {
    footerCon,
    SwipeCell,
  },
  created() {
    if (!localStorage.getItem("chatSession")) {
      localStorage.setItem("chatSession", true);
      window.location.reload();
    }
  },
  mounted() {
    this.init();
  },
  filters: {
    formatTime(m) {
      let time = new Date(m);
      var y = time.getFullYear();
      var m =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      var d = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
      var hour = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
      var minute =
        time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
      let now = y + "-" + m + "-" + d + " " + hour + ":" + minute;
      return now;
    },
  },
  methods: {
    init() {
      this.$toast.loading();
      var nim = NIM.getInstance({
        // 初始化SDK
        // debug: true,
        appKey: "c732aec34adf5d0d2006eb0323edba12",
        account: JSON.parse(localStorage.getItem("tokenObj")).accid,
        token: JSON.parse(localStorage.getItem("tokenObj")).token,
        onconnect: this.onConnect,
        onerror: this.onError,
        onwillreconnect: this.onWillReconnect,
        ondisconnect: this.onDisconnect,
        // 会话
        syncSessionUnread: true,
        onsessions: this.onSessions,
        onupdatesession: this.onUpdateSession,
        // 消息
        onroamingmsgs: this.onRoamingMsgs,
        onofflinemsgs: this.onOfflineMsgs,
        onmsg: this.onMsg,
        // 系统通知
        onofflinesysmsgs: this.onOfflineSysMsgs,
        onsysmsg: this.onSysMsg,
        onupdatesysmsg: this.onUpdateSysMsg,
        onsysmsgunread: this.onSysMsgUnread,
        // 同步完成
        onsyncdone: this.onSyncDone,
      });
      this.nim = nim;
      this.dataList = this.dataList;
      this.$forceUpdate();
    },
    onRoamingMsgs(data) {},
    onOfflineMsgs(data) {},
    onMsg() {},
    updateSessionAccount() {},
    onSyncDone() {},
    onError(error, obj) {
      this.$toast.clear();
      console.log("发生错误", error, obj);
    },
    onConnect(data) {
      this.$toast.clear();
      console.log("连接成功");
    },
    onWillReconnect(obj) {
      // 此时说明 `SDK` 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
      console.log("即将重连", obj);
    },
    onDisconnect(error) {
      // 此时说明 `SDK` 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
      console.log("连接断开", error);
      if (error) {
        switch (error.code) {
          // 账号或者密码错误, 请跳转到登录页面并提示错误
          case 302:
            this.loginError = true;
            break;
          // 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
          case 417:
            this.$toast("您已在其他设备登录，请刷新后重试");
            break;
          // 被踢, 请提示错误后跳转到登录页面
          case "kicked":
            break;
          default:
            break;
        }
      }
    },
    onSessions(sessions) {
      console.log("收到会话列表", sessions);
      sessions.forEach((item) => {
        this.nim.getUser({
          account: item.id.split("p2p-")[1],
          done: this.getUserDone,
        });
      });
      this.dataList = sessions;
      this.updateSessionsUI();
    },
    getUserDone(error, user) {
      console.log("获取用户名片" + (!error ? "成功" : "失败"), error, user);
      if (!error && user) {
        this.dataList.forEach((item, index) => {
          if (user.account === item.to) {
            this.$set(this.dataList[index], "avatar", user.avatar);
            this.$set(this.dataList[index], "nick", user.nick);
          }
        });
      }
    },
    toDetail(id, sessionId) {
      this.nim.setCurrSession(sessionId);
      this.$router.push({
        path: "/chat",
        query: {
          id,
        },
      });
    },
    onUpdateSession(session) {
      console.log("会话更新了", session);
      let data = null;
      this.$set(
        this,
        "dataList",
        this.nim.mergeSessions(this.dataList, session)
      );
      this.nim.getUser({
        account: session.id.split("p2p-")[1],
        done: this.getUserDone,
      });
      this.updateSessionsUI();
      this.$forceUpdate();
    },
    deleteSession(session, index) {
      this.nim.deleteSession({
        scene: "p2p",
        to: session.split("p2p-")[1],
        done: (error, obj) => {
          if (error) {
            return;
          }
          this.dataList.splice(index, 1);
          this.nim.deleteLocalSession({
            id: session,
            done: (error, obj) => {
              if (error) {
                return;
              }
            },
          });
        },
      });
    },
    updateSessionsUI(session) {
      // 刷新界面
    },
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem("chatSession");
    next();
  },
};
</script>
<style lang="less" scoped>
.pad_t {
  padding-top: 0.9rem;
}
.header_ {
  line-height: 0.9rem;
  font-size: 0.32rem;
  text-align: center;
  border-bottom: 1px solid #f5f5f5;
  position: fixed;
  top: 0;
  width: 100%;
}
.list {
  width: 7.04rem;
  margin: 0 auto;
}
.inner {
  .left {
    position: relative;
    margin-right: 0.2rem;
    position: relative;
    img {
      width: 0.96rem;
      height: 0.96rem;
      border-radius: 50%;
    }
    .onRead {
      padding: 0.02rem 0.04rem;
      background-color: rgb(231, 35, 35);
      color: #fff;
      font-size: 0.22rem;
      position: absolute;
      height: 0.36rem;
      min-width: 0.36rem;
      border-radius: 0.18rem;
      box-sizing: border-box;
      line-height: 0.36rem;
      text-align: center;
      right: -0.1rem;
    }
  }
  .right {
    padding: 0.3rem 0;
    width: 5.82rem;
    border-bottom: 1px solid #f5f5f5;
    .top {
      margin-bottom: 0.1rem;
      h5 {
        font-size: 0.3rem;
      }
      p {
        font-size: 0.22rem;
        color: #606060;
        margin-left: 0.1rem;
        max-width: 2.2rem;
      }
      .time {
        font-size: 0.24rem;
        color: #a0a0a0;
      }
    }
    .intro {
      font-size: 0.24rem;
      color: #a0a0a0;
    }
  }
}
/deep/ .van-button--square {
  height: 100%;
}
</style>